export default {
	title: 'Mon congé maternité',
	blocs: [
		{
			title: 'J\'exerce une activité salariée ou je perçois une allocation chômage',
			content: '<p>L\'Assurance Maladie me verse des indemnités journalières pour compenser la perte de mon salaire pendant mon congé maternité. Pour cela, il suffit que mon employeur adresse à ma caisse d\'Assurance Maladie l\'attestation de salaire dès le début de mon congé maternité.</p><a class="link" href="https://www.ameli.fr/simulateur" title="Ouvrir le simulateur (nouvelle fenêtre)" target="_blank">Calculer le montant de mes indemnités journalières</a>'
		},
		{
			title: 'Je suis travailleuse indépendante ou conjointe collaboratrice',
			content: '<p>Je peux bénéficier de prestations maternité sous certaines conditions. L\'Assurance Maladie m\'a envoyé mon carnet de prestations maternité, indispensable pour formuler mes demandes de prestations auprès de ma Caisse Primaire d\'Assurance Maladie. Je peux également retrouver ce carnet dans <a class="link" href="https://www.ameli.fr/assure/droits-demarches/famille/maternite-paternite-adoption/grossesse" title="Ouvrir la rubrique grossesse sur ameli.fr (nouvelle fenêtre)" target="_blank">la rubrique grossesse du site Ameli.fr.</a></p>'
		},
		{
			title: 'Je suis étudiante',
			content: '<p><a class="link" target="_blank" href="https://www.ameli.fr/assure/adresses-et-contacts">Je contacte ma Caisse Primaire d\'Assurance Maladie</a> (CPAM) qui m\'indiquera mes droits en fonction de ma situation.</p>'
		}
	],
	tableau:
		{
			title: 'La durée de mon congé (en semaines)',
			headers: [
				'Situation familiale',
				'Prénatal',
				'Postnatal',
				'<span class="font-weight-bold">Durée totale</span>'
			],
			conges: [
				{
					situation : '1<sup>er</sup> enfant',
					prenatal: 6,
					postnatal : 10
				},
				{
					situation : '2<sup>ème</sup> enfant avec déjà 1 enfant à charge*',
					prenatal: 6,
					postnatal : 10
				},
				{
					situation : '3<sup>ème</sup> enfant avec déjà 2 enfants à charge*',
					prenatal: 8,
					postnatal : 18
				},
				{
					situation : 'Jumeaux',
					prenatal: 12,
					postnatal : 22
				},				{
					situation : 'Triplés ou plus',
					prenatal: 24,
					postnatal : 22
				}
			]
		},
	renvoi: '* Un enfant est à votre charge s\'il réside avec vous, si vous assurez financièrement son entretien (nourriture, logement, habillement) et si vous assumez à son égard la responsabilité affective et éducative. L\'enfant doit vivre de façon permanente en France. Cela s\'applique à tous les enfants du couple. En cas de garde alternée, les parents séparés/divorcés ayant respectivement la garde des enfants, la notion de charge du foyer est retenue et l\'assurée bénéficie de l\'allongement.'
};
